const actions = {
  // Action Types for Student Personal Details Creation
  STUDENT_PERSONAL_DETAILS_CREATE_REQUEST:
    "STUDENT_PERSONAL_DETAILS_CREATE_REQUEST",
  STUDENT_PERSONAL_DETAILS_CREATE_SUCCESS:
    "STUDENT_PERSONAL_DETAILS_CREATE_SUCCESS",
  STUDENT_PERSONAL_DETAILS_CREATE_ERROR:
    "STUDENT_PERSONAL_DETAILS_CREATE_ERROR",

  // Action Types for Student Personal Details Update
  STUDENT_DETAILS_UPDATE_REQUEST: "STUDENT_DETAILS_UPDATE_REQUEST",
  STUDENT_DETAILS_UPDATE_SUCCESS: "STUDENT_DETAILS_UPDATE_SUCCESS",
  STUDENT_DETAILS_UPDATE_ERROR: "STUDENT_DETAILS_UPDATE_ERROR",

  // Action Types for Student Personal Details Get
  STUDENT_PERSONAL_DETAILS_GET_REQUEST: "STUDENT_PERSONAL_DETAILS_GET_REQUEST",
  STUDENT_PERSONAL_DETAILS_GET_SUCCESS: "STUDENT_PERSONAL_DETAILS_GET_SUCCESS",
  STUDENT_PERSONAL_DETAILS_GET_ERROR: "STUDENT_PERSONAL_DETAILS_GET_ERROR",

  ENROLLED_EXAMS_CREATE_REQUEST: "ENROLLED_EXAMS_CREATE_REQUEST",
  ENROLLED_EXAMS_CREATE_SUCCESS: "ENROLLED_EXAMS_CREATE_SUCCESS",
  ENROLLED_EXAMS_CREATE_ERROR: "ENROLLED_EXAMS_CREATE_ERROR",

  // Action Types for Reset
  RESET_ACTIONTYPE: "RESET_ACTIONTYPE",

  // Action Creators for Creating Student Personal Details
  createStudentPersonalDetails: (url, body) => ({
    type: actions.STUDENT_PERSONAL_DETAILS_CREATE_REQUEST,
    payload: { url, body },
  }),

  // Action Creators for Updating Student Personal Details
  updateStudentDetails: (url, body) => ({
    type: actions.STUDENT_DETAILS_UPDATE_REQUEST,
    payload: { url, body },
  }),

  // Action Creators for Getting Student Personal Details
  getStudentPersonalDetails: (url) => ({
    type: actions.STUDENT_PERSONAL_DETAILS_GET_REQUEST,
    payload: { url }, // URL to fetch student personal details
  }),

  createEnrolledExam: (url, body) => ({
    type: actions.ENROLLED_EXAMS_CREATE_REQUEST,
    payload: { url, body },
  }),

  // Reset Action for Student Personal Details
  resetStudentPersonalDetails: () => ({
    type: actions.RESET_ACTIONTYPE,
  }),
};

export default actions;
